import GeoJSON, { Feature } from 'geojson';

export type TCoords = [number, number];

export function coordsToFeature(coords: TCoords): Feature {
  // @ts-ignore
  return GeoJSON.parse({ name: 'location', coords }, { Point: 'coords' });
}
